import React from 'react';
import { makeStyles } from '@mui/styles';
import { Frame } from '@shopify/polaris';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { AuthContext } from './modules/auth/contexts/AuthContext';
import { APPLICATION_URL } from './modules/utils/env';
import SupportModal from './modules/supportBot/components/SupportModal';

import SourcesAutoBulkPage from './autobulkModules/sources/pages/SourcesAutoBulkPage';
import WorkOrdersAutoBulkPage from './autobulkModules/workOrders/pages/WorkOrdersAutoBulkPage';
import WorkOrdersAutoBulkDetailPage from './autobulkModules/workOrders/pages/WorkOrdersAutoBulkDetailPage';

import TransportsAutoBulkPage from './autobulkModules/transports/pages/TransportsAutoBulkPage';
import RfidsAutoBulkPage from './autobulkModules/rfid/pages/RfidAutoBulkPage';
import DriversAutoBulkPage from './autobulkModules/drivers/pages/DriversAutoBulkPage';
import TransactionApiLogsAutoBulkPage from './autobulkModules/transactionsApiLog/pages/TransactionApiLogsAutoBulkPage';

import UserAllMachinesListPage from './modules/machinesAccountManagement/pages/UserAllMachinesList';
import UserAllMachinesDetailPage from './modules/machinesAccountManagement/pages/UserAllMachinesDetail';
import UserMachinesListPage from './modules/machinesAccountManagement/pages/UserMachinesList';
import UserMachineDetailPage from './modules/machinesAccountManagement/pages/UserMachineDetail';
import MachineManagementLandingPage from './modules/machinesAccountManagement/pages/MachineManagementLandingPage';
import RemoteConsolePage from './modules/machinesAccountManagement/pages/RemoteConsolePage';
import UserCompanyDetailPage from './modules/companiesAccountManagement/pages/UserCompanyDetailsPage';

import MachineDashboardPage from './modules/machineDashboard/pages/MachineDashboardPage';

import AdminManufacturerListPage from './modules/manufacturerAdminManagement/pages/AdminManufacturerListPage';
import NewManufacturerPage from './modules/manufacturerAdminManagement/pages/NewManufacturerPage';
import EditManufacturerPage from './modules/manufacturerAdminManagement/pages/EditManufacturerPage';
import NewMfrRecipePage from './modules/manufacturerAdminManagement/pages/NewMfrRecipePage';
import EditMfrRecipePage from './modules/manufacturerAdminManagement/pages/EditMfrRecipePage';

import AdminMachineCertificatesListPage from './modules/machineCertificates/pages/MachineCertificateListPage';
import AdminMachinesListPage from './modules/machinesAdminManagement/pages/AdminMachinesList';
import AdminMachineDetailPage from './modules/machinesAdminManagement/pages/AdminMachineDetail';
import AdminNewMachinePage from './modules/machinesAdminManagement/pages/NewMachine';
import AdminMachineExecuteSql from './modules/machinesAdminManagement/pages/AdminMachineExecuteSql';
import AdminAnalyticsPage from './modules/adminAnalytics/pages/AdminAnalyticsPage';
import AdminCloudExecuteSql from './modules/auditing/pages/AdminCloudExecuteSql';
import AuditingDetail from './modules/auditing/pages/AuditingDetail';

import DatabridgeManagementPage from './modules/databridge/DataBridgeManagementPage';

import AdminUsersListPage from './modules/adminUsers/pages/UserListPage';
import AdminUserDetailPage from './modules/adminUsers/pages/UserDetailPage';
import AdminNewUserPage from './modules/adminUsers/pages/UserNewPage';

import UserUsersListPage from './modules/userUsers/pages/UserListPage';
import UserUserDetailPage from './modules/userUsers/pages/UserDetailPage';
import UserUserNewPage from './modules/userUsers/pages/UserNewPage';

import PermissionGroupsListPage from './modules/permissionGroups/pages/PermissionGroupsListPage';
import EditPermissionGroupPage from './modules/permissionGroups/pages/EditPermissionGroupPage';

import CompaniesListPage from './modules/companiesAdminManagement/pages/CompaniesListPage';
import CompanyDetailsPage from './modules/companiesAdminManagement/pages/CompanyDetailsPage';
import NewCompanyPage from './modules/companiesAdminManagement/pages/NewCompanyPage';

import AutoTreatTransactionSummary from './autotreatModules/transactions/pages/AutoTreatTransactionSummary';
import AutoTreatTreatmentProductSummary from './autotreatModules/transactions/pages/AutoTreatTreatmentProductSummary';
import SeedVarietySummary from './autotreatModules/transactions/pages/SeedVarietySummary';

import AutoBulkTransactionSummary from './autobulkModules/transactions/pages/AutoBulkTransactionSummary';
import SourceSummary from './autobulkModules/transactions/pages/SourceSummary';
import ProductSummary from './autobulkModules/transactions/pages/ProductSummary';
import ProductDetailPage from './autobulkModules/transactions/pages/ProductDetailPage';

import RealTimeActivity from './autobulkModules/realTimeDashboard/pages/RealTimeActivity';
import AutoTreatRealTimeActivity from './autotreatModules/realTimeDashboard/pages/AutoTreatRealTimeActivity';

import CustomersAutoBulkListPage from './autobulkModules/customersAutoBulk/pages/CustomersAutoBulkPage';
import ProductsAutoBulkDetailRedirectPage from './autobulkModules/products/pages/ProductsAutoBulkDetailRedirectPage';
import ProductsAutoBulkPage from './autobulkModules/products/pages/ProductsAutoBulkPage';

import CustomersAutoTreatPage from './autotreatModules/customers/pages/CustomersAutoTreatPage';
import CustomersAutoTreatcsvImportPage from './autotreatModules/customers/pages/CustomersAutoTreatcsvImportPage';
import CustomersAutoTreatcsvPartnerImportPage from './autotreatModules/customers/pages/CustomersAutoTreatcsvPartnerImportPage';
import SeedsAutoTreatPage from './autotreatModules/seeds/pages/SeedsAutoTreatPage';
import TreatmentProductsAutoTreatPage from './autotreatModules/treatmentProducts/pages/TreatmentProductsAutoTreatPage';
import RecipesAutoTreatPage from './autotreatModules/recipes/pages/RecipesAutoTreatPage';
import OrdersAutoTreatPage from './autotreatModules/orders/pages/OrdersAutoTreatPage';
import SeedSourcesAutoTreatPage from './autotreatModules/seedSources/pages/SeedSourcesAutoTreatPage';
import LiquidSourcesAutoTreatPage from './autotreatModules/liquidSources/pages/LiquidSourcesAutoTreatPage';
import TransactionApiLogsAutoTreatPage from './autotreatModules/transactionsApiLog/pages/TransactionApiLogsAutoTreatPage';
import RuntimeMetricsAutoTreatPage from './autotreatModules/runtimeMetrics/pages/RuntimeMetricsAutoTreatPage';

import NewNotificationPage from './modules/notification/pages/NewNotificationPage';
import NotificationDetailPage from './modules/notification/pages/NotificationDetailPage';
import NotificationListPage from './modules/notification/pages/NotificationListPage';

import LevelSensorsListPage from './autobulkModules/levelSensors/pages/LevelSensorsListPage';

import EdgelinkDashboard from './modules/edgelink/genericPages/EdgeLinkDashboard';
import EdgeLinkDevicesDashboardMap from './modules/edgelink/devices/pages/DevicesDashboardMap';
import EdgelinkDeviceDashboard from './modules/edgelink/devices/pages/DeviceDashboard';
import EdgeLinkDevicesDashboardCards from './modules/edgelink/devices/pages/DevicesDashboardCards';
import EdgeLinkDevicesDashboardTable from './modules/edgelink/devices/pages/DevicesDashboardTable';

import EdgelinkPublicScanPage from './modules/edgelink/genericPages/QRScanRouter';

import EdgelinkCompanyDetailsPage from './modules/edgelink/companies/pages/CompanyDetails';
import EdgelinkCompanyUsersPage from './modules/edgelink/users/pages/CompanyUsersPage';

import EdgeLinkDeviceDetailsPublic from './modules/edgelink/devices/pages/DeviceDetailsPublic';
import EdgeLinkDeviceRouter from './modules/edgelink/genericPages/DeviceRouter';
import EdgeLinkDeviceDetailsPrimary from './modules/edgelink/devices/pages/DeviceDetailsPrimary';
import EdgeLinkDeviceDetailsSecondary from './modules/edgelink/devices/pages/DeviceDetailsSecondary';
import EdgeLinkDeviceDetailsTertiary from './modules/edgelink/devices/pages/DeviceDetailsTertiary';
import EdgeLinkDeliveryTicketDashboard from './modules/edgelink/deliveryTickets/pages/deliveryTicketDashboard';
import ProductMetricsPage from './modules/edgelink/products/pages/ProductMetricsPage';

import ProductsAutoBulkcsvImportPage from './autobulkModules/products/pages/ProductsAutoBulkcsvImportPage';
import OnboardingPage from './modules/static/pages/OnboardingPage';
import UnverifiedEmailPage from './modules/static/pages/UnverifiedEmailPage';
import InvalidAccountPage from './modules/static/pages/InvalidAccountPage';
import HomePage from './modules/static/pages/HomePage';
import Sidebar from './modules/navigation/components/Sidebar';
import TopNavigation from './modules/navigation/components/TopNavigation';
import UserTopNavigation from './modules/navigation/components/UserTopNavigation';
import UserProfilePage from './modules/userUsers/pages/UserProfilePage';
import MachineRequestsPage from './modules/machineRequests/pages/MachineRequestsPage';
import MachineRequestRecordsPage from './modules/machineRequests/pages/MachineRequestRecordsPage';
import MachineRequestRecordDetails from './modules/machineRequests/pages/MachineRequestRecordDetails';
import ProductsAutoBulkcsvPartnerImportPage from './autobulkModules/products/pages/ProductsAutoBulkcsvPartnerImportPage';
import CustomersAutoBulkcsvImportPage from './autobulkModules/customersAutoBulk/pages/CustomersAutoBulkcsvImportPage';
import CustomersAutoBulkcsvPartnerImportPage from './autobulkModules/customersAutoBulk/pages/CustomersAutoBulkcsvPartnerImportPage';
import SeedsAutoTreatcsvImportPage from './autotreatModules/seeds/pages/SeedsAutoTreatcsvImportPage';
import SeedsAutoTreatcsvPartnerImportPage from './autotreatModules/seeds/pages/SeedsAutoTreatcsvPartnerImportPage';
import DeploymentsCreate from './modules/machineDeployments/pages/DeploymentsCreate';
import DeploymentsList from './modules/machineDeployments/pages/DeploymentsList';
import DeploymentsTemporaryResponse from './modules/machineDeployments/pages/DeploymentsTemporaryResponse';
import SoftwareVersionsList from './modules/softwareVersions/pages/SoftwareVersionsList';
import SoftwareVersionsCreate from './modules/softwareVersions/pages/SoftwareVersionsCreate';
import EcrDeploymentsMain from './modules/ecrDeployments/pages/EcrDeploymentsMain';
import { EcrDeploymentsProvider } from './modules/ecrDeployments/contexts/EcrDeploymentsContext';
import AgconnexSnackbar from './modules/snackBar/components/AgconnexSnackbar';
import ContainerDashboard from './modules/edgelink/containers/ContainersPage';
import DevicesManagementPage from './modules/edgelink/admin/DevicesManagement/DevicesManagementPage';
import CompaniesManagementPage from './modules/edgelink/admin/CompaniesManagement/CompaniesManagementPage';

const useStyles = makeStyles((theme: any) => ({
  box: {
    width: '100%',
  },
  content: {
    width: '100%',
    marginTop: '65px',
  },
}));

const Routes: React.FC = () => {
  const classes = useStyles();

  const { isAuthenticated, isLoading } = useAuth0();
  const [mobileNavigationActive, setMobileNavigationActive] = React.useState<boolean>(false);
  const skipToContentRef = React.useRef<HTMLAnchorElement>(null);
  const { permissionsLoading, currentUserHasAdminPermission } = React.useContext(AuthContext);

  const ProtectedRoute = ({ component: Component, path, exact = true }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        isAuthenticated ? (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={permissionsLoading ? <div /> : <Sidebar />}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <AgconnexSnackbar />
            <div style={{ padding: 30 }}>{permissionsLoading ? <div /> : <Component props={props} component />}</div>
          </Frame>
        ) : (
          <Redirect to={`/login?redirect_url=${window.location.href}`} />
        )
      }
    />
  );

  const ProtectedAdminRoute = ({ component: Component, path, exact = true }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        isAuthenticated ? (
          <>
            {!permissionsLoading && !currentUserHasAdminPermission('ksi_support') ? (
              <Redirect to="/login" />
            ) : (
              <Frame
                topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
                navigation={permissionsLoading ? <div /> : <Sidebar />}
                showMobileNavigation={mobileNavigationActive}
                onNavigationDismiss={() => setMobileNavigationActive(false)}
                skipToContentTarget={skipToContentRef}
              >
                <AgconnexSnackbar />
                <div style={{ padding: 30 }}>{permissionsLoading ? <div /> : <Component props={props} component />}</div>
                <SupportModal />
              </Frame>
            )}
          </>
        ) : (
          <Redirect to={`/login?redirect_url=${window.location.href}`} />
        )
      }
    />
  );

  const AuthRoute = ({ component: Component, path }) => (
    <Route
      path={path}
      render={(props) => (
        <>
          <TopNavigation />
          <main role="main" className={classes.content}>
            <Component props={props} component />
          </main>
        </>
      )}
    />
  );

  const UnstyledRoute = ({ component: Component, path }) => <Route path={path} render={(props) => <Component props={props} component />} />;

  return isLoading ? (
    <Switch />
  ) : (
    <Switch>
      <AuthRoute path="/login" component={() => <HomePage />} />
      <AuthRoute path="/sign_up" component={() => <OnboardingPage />} />
      <AuthRoute path="/invalid_account" component={() => <InvalidAccountPage />} />
      <AuthRoute path="/unverified_email" component={() => <UnverifiedEmailPage />} />
      {/* Admin Permission Management */}
      <ProtectedAdminRoute exact path="/admin/permission_management" component={() => <PermissionGroupsListPage />} />
      <ProtectedAdminRoute exact path="/admin/permission_management/:permissionGroupId/edit" component={() => <EditPermissionGroupPage />} />
      {/* Admin Execute Machine SQL */}
      <ProtectedAdminRoute exact path="/admin/machine_execute_sql" component={() => <AdminMachineExecuteSql />} />
      {/* Software Deployments */}
      <ProtectedAdminRoute exact path="/admin/machine_deployments" component={() => <DeploymentsList />} />
      <ProtectedAdminRoute exact path="/admin/machine_deployments/create" component={() => <DeploymentsCreate />} />
      <ProtectedAdminRoute exact path="/admin/machine_deployments/temporary_response" component={() => <DeploymentsTemporaryResponse />} />
      {/* Manage Software Versions */}
      <ProtectedAdminRoute exact path="/admin/software_versions" component={() => <SoftwareVersionsList />} />
      <ProtectedAdminRoute exact path="/admin/software_versions/create" component={() => <SoftwareVersionsCreate />} />
      {/* ECR Deployments */}
      <ProtectedAdminRoute exact path="/admin/ecr_deployments" component={() => <EcrDeploymentsProvider><EcrDeploymentsMain /></EcrDeploymentsProvider>} />
      <ProtectedAdminRoute exact path="/admin/ecr_deployments/assignments" component={() => <EcrDeploymentsProvider><EcrDeploymentsMain /></EcrDeploymentsProvider>} />
      <ProtectedAdminRoute exact path="/admin/ecr_deployments/env-vars" component={() => <EcrDeploymentsProvider><EcrDeploymentsMain /></EcrDeploymentsProvider>} />
      {/* Admin Dashboard */}
      <ProtectedAdminRoute exact path="/admin/auditing" component={() => <AuditingDetail />} />
      <ProtectedAdminRoute exact path="/admin/cloud_execute_sql" component={() => <AdminCloudExecuteSql />} />
      <ProtectedAdminRoute exact path="/admin/internal_analytics_autotreat" component={() => <AdminAnalyticsPage />} />
      {/* Admin Machine Management */}
      <ProtectedAdminRoute exact path="/admin/databridge_management" component={() => <DatabridgeManagementPage />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/partners" component={() => <DatabridgeManagementPage initialTab="partners" />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/partners/new" component={() => <DatabridgeManagementPage initialTab="partners" formMode="new" />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/partners/:partnerId" component={() => <DatabridgeManagementPage initialTab="partners" formMode="edit" />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/adapters" component={() => <DatabridgeManagementPage initialTab="adapters" />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/integrations" component={() => <DatabridgeManagementPage initialTab="integrations" />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/integrations/new" component={() => <DatabridgeManagementPage initialTab="integrations" formMode="new" />} />
      <ProtectedAdminRoute exact path="/admin/databridge_management/integrations/:integrationId" component={() => <DatabridgeManagementPage initialTab="integrations" formMode="edit" />} />
      {/* Admin Machine Management */}
      <ProtectedAdminRoute exact path="/admin/machine_management" component={() => <AdminMachinesListPage />} />
      <ProtectedAdminRoute exact path="/admin/manufacturer_management" component={() => <AdminManufacturerListPage />} />
      <ProtectedAdminRoute exact path="/admin/manufacturers/new" component={() => <NewManufacturerPage />} />
      <ProtectedAdminRoute exact path="/admin/autotreat_mfr/mfrs/:id" component={EditManufacturerPage} />
      <ProtectedAdminRoute exact path="/admin/manufacturers/:id/edit" component={EditManufacturerPage} />
      <ProtectedAdminRoute exact path="/admin/recipes/new" component={NewMfrRecipePage} />
      <ProtectedAdminRoute exact path="/admin/recipes/:id/edit" component={EditMfrRecipePage} />
      <ProtectedAdminRoute exact path="/admin/autotreat_mfr/mfr_recipes/:id/edit" component={EditMfrRecipePage} />
      <ProtectedAdminRoute exact path="/admin/autotreat_mfr/mfr_recipes/:id" component={EditMfrRecipePage} />
      <ProtectedAdminRoute exact path="/admin/machine_management/new" component={() => <AdminNewMachinePage />} />
      <ProtectedAdminRoute exact path="/admin/machine_certificates" component={() => <AdminMachineCertificatesListPage />} />
      <ProtectedAdminRoute exact path="/admin/machine_management/new/company/:companyId" component={() => <AdminNewMachinePage />} />
      <ProtectedAdminRoute exact path="/admin/machine_management/:machineId" component={() => <AdminMachineDetailPage />} />
      <ProtectedAdminRoute exact path="/admin/machine_management/:machineId/:tab" component={() => <AdminMachineDetailPage />} />
      <ProtectedRoute exact path="/machine-management" component={() => <MachineManagementLandingPage />} />
      <ProtectedRoute exact path="/user/machine_management/:machineId" component={() => <UserMachineDetailPage />} />
      <ProtectedRoute exact path="/user/machine_management/:machineId/:tab" component={() => <UserMachineDetailPage />} />
      {/* Admin User Management */}
      <ProtectedAdminRoute exact path="/admin/user_management" component={() => <AdminUsersListPage />} />
      <ProtectedAdminRoute exact path="/admin/user_management/new" component={() => <AdminNewUserPage />} />
      <ProtectedAdminRoute exact path="/admin/user_management/new/company/:companyId" component={() => <AdminNewUserPage />} />
      <ProtectedAdminRoute exact path="/admin/user_management/:userId" component={() => <AdminUserDetailPage />} />
      <ProtectedAdminRoute exact path="/admin/user_management/:userId/:tab" component={() => <AdminUserDetailPage />} />
      {/* Account User Management */}
      <ProtectedRoute exact path="/account_management/users" component={() => <UserUsersListPage />} />
      <ProtectedRoute exact path="/account_management/users/new" component={() => <UserUserNewPage />} />
      <ProtectedRoute exact path="/account_management/users/:userId" component={() => <UserUserDetailPage />} />
      <ProtectedRoute exact path="/profile" component={() => <UserProfilePage />} />
      {/* Machine Request */}
      <ProtectedRoute exact path="/machine_requests" component={() => <MachineRequestsPage />} />
      <ProtectedRoute exact path="/machine_requests/:machineRequestId/machine_request_records" component={() => <MachineRequestRecordsPage />} />
      {/* TODO below should only be for ksi super admins - columns verical with the value to the right */}
      <ProtectedAdminRoute exact path="/machine_requests/:machineRequestId/machine_request_records/:machineRequestRecordId" component={() => <MachineRequestRecordDetails />} />
      {/* Account Machines Management */}
      <ProtectedRoute exact path="/account_management/company_machines" component={() => <UserAllMachinesListPage />} />
      <ProtectedRoute exact path="/account_management/company_machines/:machineSerial" component={() => <UserAllMachinesDetailPage />} />
      <ProtectedRoute exact path="/account_management/company_machines/:machineSerial/:tab" component={() => <UserAllMachinesDetailPage />} />
      <ProtectedRoute exact path="/account_management/company" component={() => <UserCompanyDetailPage />} />
      <ProtectedRoute exact path="/account_management/my_machines" component={() => <UserMachinesListPage />} />
      <ProtectedRoute exact path="/account_management/my_machines/:machineSerial" component={() => <UserMachineDetailPage />} />
      {/* Notification Management */}
      <ProtectedRoute exact path="/account_management/notifications/new" component={() => <NewNotificationPage />} />
      <ProtectedRoute exact path="/account_management/notifications/:notificationId" component={() => <NotificationDetailPage />} />
      <ProtectedRoute exact path="/account_management/notifications/" component={() => <NotificationListPage />} />
      {/* Admin Company Management */}
      <ProtectedAdminRoute exact path="/admin/company_management" component={() => <CompaniesListPage />} />
      <ProtectedAdminRoute exact path="/admin/company_management/new" component={() => <NewCompanyPage />} />
      <ProtectedAdminRoute exact path="/admin/company_management/:companyId" component={() => <CompanyDetailsPage />} />
      <ProtectedAdminRoute exact path="/admin/company_management/:companyId/:tab" component={() => <CompanyDetailsPage />} />
      {/* AutoTreat Analytics */}
      <ProtectedRoute exact path="/autotreat/analytics" component={() => <AutoTreatTransactionSummary />} />
      <ProtectedRoute exact path="/autotreat/analytics/seed_variety_summary" component={() => <SeedVarietySummary />} />
      <ProtectedRoute exact path="/autotreat/analytics/transaction_summary" component={() => <AutoTreatTransactionSummary />} />
      <ProtectedRoute exact path="/autotreat/analytics/treatment_product_summary" component={() => <AutoTreatTreatmentProductSummary />} />
      {/* AutoTreat Machine Management Pages */}
      <ProtectedRoute exact path="/autotreat/remote-console" component={() => <RemoteConsolePage />} />
      <ProtectedRoute exact path="/autotreat/machines/:machineSerial/customers_import" component={() => <CustomersAutoTreatcsvImportPage />} />
      <ProtectedRoute exact path="/autotreat/machines/:machineSerial/partners/customers_import" component={() => <CustomersAutoTreatcsvPartnerImportPage />} />
      <ProtectedRoute exact path="/autotreat/machines/customers" component={() => <CustomersAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/liquid_sources" component={() => <LiquidSourcesAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/orders" component={() => <OrdersAutoTreatPage />} />
      {/* <ProtectedRoute exact path="/autotreat/machines/orders/new" component={() => <OrdersAutoTreatPage />} /> */}
      <ProtectedRoute exact path="/autotreat/machines/recipes" component={() => <RecipesAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/seed_sources" component={() => <SeedSourcesAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/seeds" component={() => <SeedsAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/:machineSerial/seeds_import" component={() => <SeedsAutoTreatcsvImportPage />} />
      <ProtectedRoute exact path="/autotreat/machines/:machineSerial/partners/seeds_import" component={() => <SeedsAutoTreatcsvPartnerImportPage />} />
      <ProtectedRoute exact path="/autotreat/machines/transaction_api_log" component={() => <TransactionApiLogsAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/runtime_metrics" component={() => <RuntimeMetricsAutoTreatPage />} />
      <ProtectedRoute exact path="/autotreat/machines/treat_products" component={() => <TreatmentProductsAutoTreatPage />} />
      {/* AutoTreat Misc */}
      <ProtectedRoute exact path="/autotreat/real_time_activity" component={() => <AutoTreatRealTimeActivity />} />
      {/* AutoBulk Analytics */}
      <ProtectedRoute exact path="/autobulk/analytics/product_summary" component={() => <ProductSummary />} />
      <ProtectedRoute exact path="/autobulk/analytics/source_summary" component={() => <SourceSummary />} />
      <ProtectedRoute exact path="/autobulk/analytics/transaction_summary" component={() => <AutoBulkTransactionSummary />} />
      <ProtectedRoute exact path="/autobulk/analytics/transactions/products/details" component={() => <ProductDetailPage />} />
      {/* AutoBulk Machine Management Pages */}
      <ProtectedRoute exact path="/autobulk/remote-console" component={() => <RemoteConsolePage />} />
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/products/:productId" component={() => <ProductsAutoBulkDetailRedirectPage />} />
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/work_orders/:id" component={() => <WorkOrdersAutoBulkDetailPage />} />
      {/* new autobulk import urls */}
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/customers_import" component={() => <CustomersAutoBulkcsvImportPage />} />
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/partners/customers_import" component={() => <CustomersAutoBulkcsvPartnerImportPage />} />
      <ProtectedRoute exact path="/autobulk/machines/customers/" component={() => <CustomersAutoBulkListPage />} />
      <ProtectedRoute exact path="/autobulk/machines/drivers/" component={() => <DriversAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/drivers" component={() => <DriversAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/drivers/:driverId" component={() => <DriversAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/products/" component={() => <ProductsAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/rfids/" component={() => <RfidsAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/sources" component={() => <SourcesAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/transaction_api_log" component={() => <TransactionApiLogsAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/transports/" component={() => <TransportsAutoBulkPage />} />
      <ProtectedRoute exact path="/autobulk/machines/work_orders/" component={() => <WorkOrdersAutoBulkPage />} />
      {/* Remote Console */}
      <ProtectedRoute exact path="/machines/remote-console" component={() => <RemoteConsolePage />} />
      {/* AutoBulk Misc */}
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/products_import/" component={() => <ProductsAutoBulkcsvImportPage />} />
      <ProtectedRoute exact path="/autobulk/machines/:machineSerial/partners/products_import/" component={() => <ProductsAutoBulkcsvPartnerImportPage />} />
      {/* Level Sensor Routes */}
      <ProtectedRoute exact path="/autobulk/level_sensors" component={() => <LevelSensorsListPage />} />
      <ProtectedRoute exact path="/level_sensors/dashboard" component={() => <LevelSensorsListPage />} />

      {/* EdgeLink Routes */}
      <ProtectedRoute exact path="/edgelink/devices/:edgelinkId/dashboard" component={EdgelinkDeviceDashboard} />
      <ProtectedRoute exact path="/edgelink/devices/map" component={EdgeLinkDevicesDashboardMap} />
      <ProtectedRoute exact path="/edgelink/devices/cards" component={EdgeLinkDevicesDashboardCards} />
      <ProtectedRoute exact path="/edgelink/devices/table" component={EdgeLinkDevicesDashboardTable} />

      <ProtectedRoute exact path="/edgelink/company/" component={EdgelinkCompanyDetailsPage} />
      <ProtectedRoute exact path="/edgelink/company/users" component={EdgelinkCompanyUsersPage} />

      <ProtectedRoute exact path="/edgelink" component={EdgelinkDashboard} />

      <ProtectedRoute exact path="/edgelink/devices/:deviceSerial/primary" component={EdgeLinkDeviceDetailsPrimary} />
      <ProtectedRoute exact path="/edgelink/devices/:deviceSerial/secondary" component={EdgeLinkDeviceDetailsSecondary} />
      <ProtectedRoute exact path="/edgelink/devices/:deviceSerial/tertiary" component={EdgeLinkDeviceDetailsTertiary} />

      <ProtectedRoute exact path="/edgelink/device_router/:deviceSerial" component={EdgeLinkDeviceRouter} />

      <ProtectedRoute exact path="/edgelink/delivery_tickets" component={EdgeLinkDeliveryTicketDashboard} />

      <ProtectedRoute exact path="/edgelink/products" component={ProductMetricsPage} />
      <ProtectedRoute exact path="/edgelink/containers" component={ContainerDashboard} />
      <ProtectedRoute exact path="/edgelink/containers/create" component={ContainerDashboard} />
      <ProtectedRoute exact path="/edgelink/containers/edit/:containerSerial" component={ContainerDashboard} />

      <ProtectedRoute exact path="/edgelink/admin/devices" component={DevicesManagementPage} />
      <ProtectedRoute exact path="/edgelink/admin/companies" component={CompaniesManagementPage} />

      <Route path="/edgelink/devices/:deviceSerial/public" component={EdgeLinkDeviceDetailsPublic} />
      <Route path="/scan" component={EdgelinkPublicScanPage} />

      {/* Catch-all redirect for any /edgelink/* route */}
      <Route path="/edgelink/*">
        <Redirect to="/edgelink" />
      </Route>

      <ProtectedRoute exact path="/autobulk/real_time_activity" component={() => <RealTimeActivity />} />
      <ProtectedRoute exact path="/" component={() => <MachineDashboardPage />} />
      <ProtectedRoute exact={false} path="/:params" component={() => <Redirect to="/" />} />
    </Switch>
  );
};

export default Routes;
